import type { PaymentType as GQLPaymentType } from '@change-corgi/middle-end-gql-schema';

import type { PaymentType } from './types';

const paymentTypeMap: Record<PaymentType, GQLPaymentType> = {
	applePay: 'APPLE_PAY',
	creditCard: 'CREDIT_CARD',
	googlePay: 'GOOGLE_PAY',
	paypal: 'PAYPAL',
	sepa: 'SEPA_DEBIT',
	link: 'LINK',
};

const reversePaymentTypeMap: Partial<Record<GQLPaymentType, PaymentType>> = {
	APPLE_PAY: 'applePay',
	CREDIT_CARD: 'creditCard',
	GOOGLE_PAY: 'googlePay',
	PAYPAL: 'paypal',
	SEPA_DEBIT: 'sepa',
	LINK: 'link',
};

export function gqlPaymentType(paymentType: PaymentType): GQLPaymentType {
	return paymentTypeMap[paymentType];
}

export function fromGqlPaymentType(paymentType: GQLPaymentType): PaymentType {
	const result = reversePaymentTypeMap[paymentType];
	if (!result) throw new Error(`Unsupported payment type: ${paymentType}`);
	return result;
}
